"use strict";
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiException = exports.SubscriptionStatus = exports.SubscriptionType = exports.SubscriptionDuration = exports.PurchaseSourceType = exports.RetentionPeriod = exports.PlanType = exports.ContentType = exports.SectionType = exports.EndpointFieldType = exports.EndpointTypes = exports.ResponseCode = exports.AppWatch_WajeezQueries_Client = exports.AppWatch_Stripe_Client = exports.AppWatch_PaymentQueries_Client = exports.AppWatch_IdentityQueries_Client = exports.AppWatch_ContentQueries_Client = exports.AppWatch_AppleReports_Client = exports.AppWatch_DataWorkflow_Client = exports.AppWatch_Template_Client = exports.AppWatch_TemplateCategory_Client = exports.AppWatch_Section_Client = exports.AppWatch_EndpointSegments_Client = exports.AppWatch_Endpoint_Client = exports.AppWatch_Department_Client = exports.AppWatch_WebHook_Client = void 0;
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
var axios_1 = __importDefault(require("axios"));
var AppWatch_WebHook_Client = /** @class */ (function () {
    function AppWatch_WebHook_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Consume Pubsub Messages (Scope: Dashboard)
     */
    AppWatch_WebHook_Client.prototype.webHook_post_V1 = function (pushBody, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/WebHook";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(pushBody);
        var options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWebHook_post_V1(_response);
        });
    };
    AppWatch_WebHook_Client.prototype.processWebHook_post_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            var contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            var fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            var fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return AppWatch_WebHook_Client;
}());
exports.AppWatch_WebHook_Client = AppWatch_WebHook_Client;
var AppWatch_Department_Client = /** @class */ (function () {
    function AppWatch_Department_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * (Scope: Dashboard)
     */
    AppWatch_Department_Client.prototype.department_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Department";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDepartment_V1POST(_response);
        });
    };
    AppWatch_Department_Client.prototype.processDepartment_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile; Dashboard)
     * @param input (optional)
     */
    AppWatch_Department_Client.prototype.department_V1GET = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Department?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDepartment_V1GET(_response);
        });
    };
    AppWatch_Department_Client.prototype.processDepartment_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard)
     */
    AppWatch_Department_Client.prototype.department_V1DELETE = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Department";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDepartment_V1DELETE(_response);
        });
    };
    AppWatch_Department_Client.prototype.processDepartment_V1DELETE = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard)
     * @param departmentId (optional)
     */
    AppWatch_Department_Client.prototype.department_byId_V1 = function (departmentId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Department/by-Id?";
        if (departmentId === null)
            throw new Error("The parameter 'departmentId' cannot be null.");
        else if (departmentId !== undefined)
            url_ += "DepartmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDepartment_byId_V1(_response);
        });
    };
    AppWatch_Department_Client.prototype.processDepartment_byId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return AppWatch_Department_Client;
}());
exports.AppWatch_Department_Client = AppWatch_Department_Client;
var AppWatch_Endpoint_Client = /** @class */ (function () {
    function AppWatch_Endpoint_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * (Scope: Dashboard)
     */
    AppWatch_Endpoint_Client.prototype.endpoint_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Endpoint";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processEndpoint_V1POST(_response);
        });
    };
    AppWatch_Endpoint_Client.prototype.processEndpoint_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard)
     */
    AppWatch_Endpoint_Client.prototype.endpoint_V1DELETE = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Endpoint";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processEndpoint_V1DELETE(_response);
        });
    };
    AppWatch_Endpoint_Client.prototype.processEndpoint_V1DELETE = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard)
     * @param endpointSegmentId (optional)
     */
    AppWatch_Endpoint_Client.prototype.endpoint_V1GET = function (endpointSegmentId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Endpoint?";
        if (endpointSegmentId !== undefined && endpointSegmentId !== null)
            url_ += "EndpointSegmentId=" + encodeURIComponent("" + endpointSegmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processEndpoint_V1GET(_response);
        });
    };
    AppWatch_Endpoint_Client.prototype.processEndpoint_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile; Dashboard)
     * @param endpointId (optional)
     */
    AppWatch_Endpoint_Client.prototype.endpoint_byId_V1 = function (endpointId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Endpoint/by-Id?";
        if (endpointId === null)
            throw new Error("The parameter 'endpointId' cannot be null.");
        else if (endpointId !== undefined)
            url_ += "EndpointId=" + encodeURIComponent("" + endpointId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processEndpoint_byId_V1(_response);
        });
    };
    AppWatch_Endpoint_Client.prototype.processEndpoint_byId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return AppWatch_Endpoint_Client;
}());
exports.AppWatch_Endpoint_Client = AppWatch_Endpoint_Client;
var AppWatch_EndpointSegments_Client = /** @class */ (function () {
    function AppWatch_EndpointSegments_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * (Scope: Mobile)
     */
    AppWatch_EndpointSegments_Client.prototype.endpointSegments_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/EndpointSegments";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processEndpointSegments_V1POST(_response);
        });
    };
    AppWatch_EndpointSegments_Client.prototype.processEndpointSegments_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @param input (optional)
     */
    AppWatch_EndpointSegments_Client.prototype.endpointSegments_V1GET = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/EndpointSegments?";
        if (input !== undefined && input !== null)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processEndpointSegments_V1GET(_response);
        });
    };
    AppWatch_EndpointSegments_Client.prototype.processEndpointSegments_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return AppWatch_EndpointSegments_Client;
}());
exports.AppWatch_EndpointSegments_Client = AppWatch_EndpointSegments_Client;
var AppWatch_Section_Client = /** @class */ (function () {
    function AppWatch_Section_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * (Scope: Dashboard)
     */
    AppWatch_Section_Client.prototype.section_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Section";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSection_V1POST(_response);
        });
    };
    AppWatch_Section_Client.prototype.processSection_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard)
     */
    AppWatch_Section_Client.prototype.section_V1DELETE = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Section";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSection_V1DELETE(_response);
        });
    };
    AppWatch_Section_Client.prototype.processSection_V1DELETE = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard)
     * @param collectionRowId (optional)
     */
    AppWatch_Section_Client.prototype.section_V1GET = function (collectionRowId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Section?";
        if (collectionRowId !== undefined && collectionRowId !== null)
            url_ += "CollectionRowId=" + encodeURIComponent("" + collectionRowId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSection_V1GET(_response);
        });
    };
    AppWatch_Section_Client.prototype.processSection_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard)
     */
    AppWatch_Section_Client.prototype.section_update_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Section/update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSection_update_V1(_response);
        });
    };
    AppWatch_Section_Client.prototype.processSection_update_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Dashboard)
     * @param id (optional)
     */
    AppWatch_Section_Client.prototype.section_byId_V1 = function (id, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Section/by-id?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processSection_byId_V1(_response);
        });
    };
    AppWatch_Section_Client.prototype.processSection_byId_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return AppWatch_Section_Client;
}());
exports.AppWatch_Section_Client = AppWatch_Section_Client;
var AppWatch_TemplateCategory_Client = /** @class */ (function () {
    function AppWatch_TemplateCategory_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * (Scope: Mobile)
     * @param departmentId (optional)
     */
    AppWatch_TemplateCategory_Client.prototype.templateCategory_templateCategories_V1GET = function (departmentId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/TemplateCategory/templateCategories?";
        if (departmentId !== undefined && departmentId !== null)
            url_ += "DepartmentId=" + encodeURIComponent("" + departmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTemplateCategory_templateCategories_V1GET(_response);
        });
    };
    AppWatch_TemplateCategory_Client.prototype.processTemplateCategory_templateCategories_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    AppWatch_TemplateCategory_Client.prototype.templateCategory_templateCategories_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/TemplateCategory/templateCategories";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTemplateCategory_templateCategories_V1POST(_response);
        });
    };
    AppWatch_TemplateCategory_Client.prototype.processTemplateCategory_templateCategories_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @param templateCategoryId (optional)
     */
    AppWatch_TemplateCategory_Client.prototype.templateCategory_templateCategories_V1DELETE = function (templateCategoryId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/TemplateCategory/templateCategories?";
        if (templateCategoryId === null)
            throw new Error("The parameter 'templateCategoryId' cannot be null.");
        else if (templateCategoryId !== undefined)
            url_ += "TemplateCategoryId=" + encodeURIComponent("" + templateCategoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTemplateCategory_templateCategories_V1DELETE(_response);
        });
    };
    AppWatch_TemplateCategory_Client.prototype.processTemplateCategory_templateCategories_V1DELETE = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return AppWatch_TemplateCategory_Client;
}());
exports.AppWatch_TemplateCategory_Client = AppWatch_TemplateCategory_Client;
var AppWatch_Template_Client = /** @class */ (function () {
    function AppWatch_Template_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * (Scope: Mobile)
     */
    AppWatch_Template_Client.prototype.template_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Template";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTemplate_V1POST(_response);
        });
    };
    AppWatch_Template_Client.prototype.processTemplate_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    AppWatch_Template_Client.prototype.template_V1DELETE = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Template";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTemplate_V1DELETE(_response);
        });
    };
    AppWatch_Template_Client.prototype.processTemplate_V1DELETE = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @param templateCategoryId (optional)
     */
    AppWatch_Template_Client.prototype.template_V1GET = function (templateCategoryId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Template?";
        if (templateCategoryId !== undefined && templateCategoryId !== null)
            url_ += "TemplateCategoryId=" + encodeURIComponent("" + templateCategoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTemplate_V1GET(_response);
        });
    };
    AppWatch_Template_Client.prototype.processTemplate_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    AppWatch_Template_Client.prototype.template_rows_V1POST = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Template/rows";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTemplate_rows_V1POST(_response);
        });
    };
    AppWatch_Template_Client.prototype.processTemplate_rows_V1POST = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @param templateId (optional)
     */
    AppWatch_Template_Client.prototype.template_rows_V1GET = function (templateId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Template/rows?";
        if (templateId === null)
            throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "TemplateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTemplate_rows_V1GET(_response);
        });
    };
    AppWatch_Template_Client.prototype.processTemplate_rows_V1GET = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    AppWatch_Template_Client.prototype.template_update_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Template/update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTemplate_update_V1(_response);
        });
    };
    AppWatch_Template_Client.prototype.processTemplate_update_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     */
    AppWatch_Template_Client.prototype.template_row_V1 = function (input, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Template/row";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTemplate_row_V1(_response);
        });
    };
    AppWatch_Template_Client.prototype.processTemplate_row_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Scope: Mobile)
     * @param templateId (optional)
     */
    AppWatch_Template_Client.prototype.template_views_V1 = function (templateId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Template/views?";
        if (templateId === null)
            throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "TemplateId=" + encodeURIComponent("" + templateId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processTemplate_views_V1(_response);
        });
    };
    AppWatch_Template_Client.prototype.processTemplate_views_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return AppWatch_Template_Client;
}());
exports.AppWatch_Template_Client = AppWatch_Template_Client;
var AppWatch_DataWorkflow_Client = /** @class */ (function () {
    function AppWatch_DataWorkflow_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    AppWatch_DataWorkflow_Client.prototype.dataWorkflow_get_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/DataWorkflow";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processDataWorkflow_get_V1(_response);
        });
    };
    AppWatch_DataWorkflow_Client.prototype.processDataWorkflow_get_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return AppWatch_DataWorkflow_Client;
}());
exports.AppWatch_DataWorkflow_Client = AppWatch_DataWorkflow_Client;
var AppWatch_AppleReports_Client = /** @class */ (function () {
    function AppWatch_AppleReports_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * (Auth policies: 100.0) (Scope: Mobile)
     * @param startDate (optional)
     * @param endDate (optional)
     */
    AppWatch_AppleReports_Client.prototype.fetchAppleReports_V1 = function (startDate, endDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/AppleReports/fetchAppleReports?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processFetchAppleReports_V1(_response);
        });
    };
    AppWatch_AppleReports_Client.prototype.processFetchAppleReports_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return AppWatch_AppleReports_Client;
}());
exports.AppWatch_AppleReports_Client = AppWatch_AppleReports_Client;
var AppWatch_ContentQueries_Client = /** @class */ (function () {
    function AppWatch_ContentQueries_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * (Auth policies: 120.0)
     * @param contentEntityTypeId (optional)
     */
    AppWatch_ContentQueries_Client.prototype.contentQueries_contentTypeCount_V1 = function (contentEntityTypeId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/content-type-count?";
        if (contentEntityTypeId === null)
            throw new Error("The parameter 'contentEntityTypeId' cannot be null.");
        else if (contentEntityTypeId !== undefined)
            url_ += "contentEntityTypeId=" + encodeURIComponent("" + contentEntityTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentQueries_contentTypeCount_V1(_response);
        });
    };
    AppWatch_ContentQueries_Client.prototype.processContentQueries_contentTypeCount_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.1)
     * @param userId (optional)
     */
    AppWatch_ContentQueries_Client.prototype.contentQueries_userConsumedContent_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/user-consumed-content?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentQueries_userConsumedContent_V1(_response);
        });
    };
    AppWatch_ContentQueries_Client.prototype.processContentQueries_userConsumedContent_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.2)
     * @param userId (optional)
     */
    AppWatch_ContentQueries_Client.prototype.contentQueries_dailyUserSessionBreakdown_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/daily-user-session-breakdown?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentQueries_dailyUserSessionBreakdown_V1(_response);
        });
    };
    AppWatch_ContentQueries_Client.prototype.processContentQueries_dailyUserSessionBreakdown_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.3)
     * @param userId (optional)
     */
    AppWatch_ContentQueries_Client.prototype.contentQueries_monthlyUserSessionBreakdown_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/monthly-user-session-breakdown?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentQueries_monthlyUserSessionBreakdown_V1(_response);
        });
    };
    AppWatch_ContentQueries_Client.prototype.processContentQueries_monthlyUserSessionBreakdown_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.4)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param contentType (optional)
     * @param planType (optional)
     */
    AppWatch_ContentQueries_Client.prototype.contentQueries_topContent_V1 = function (fromDate, toDate, contentType, planType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/top-content?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (contentType === null)
            throw new Error("The parameter 'contentType' cannot be null.");
        else if (contentType !== undefined)
            url_ += "contentType=" + encodeURIComponent("" + contentType) + "&";
        if (planType === null)
            throw new Error("The parameter 'planType' cannot be null.");
        else if (planType !== undefined)
            url_ += "planType=" + encodeURIComponent("" + planType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentQueries_topContent_V1(_response);
        });
    };
    AppWatch_ContentQueries_Client.prototype.processContentQueries_topContent_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.5)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param contentType (optional)
     * @param planType (optional)
     */
    AppWatch_ContentQueries_Client.prototype.contentQueries_mostRatedContent_V1 = function (fromDate, toDate, contentType, planType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/most-rated-content?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (contentType === null)
            throw new Error("The parameter 'contentType' cannot be null.");
        else if (contentType !== undefined)
            url_ += "contentType=" + encodeURIComponent("" + contentType) + "&";
        if (planType === null)
            throw new Error("The parameter 'planType' cannot be null.");
        else if (planType !== undefined)
            url_ += "planType=" + encodeURIComponent("" + planType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentQueries_mostRatedContent_V1(_response);
        });
    };
    AppWatch_ContentQueries_Client.prototype.processContentQueries_mostRatedContent_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.6)
     * @param planType (optional)
     */
    AppWatch_ContentQueries_Client.prototype.contentQueries_minutesListenedToday_V1 = function (planType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/minutes-listened-today?";
        if (planType === null)
            throw new Error("The parameter 'planType' cannot be null.");
        else if (planType !== undefined)
            url_ += "planType=" + encodeURIComponent("" + planType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentQueries_minutesListenedToday_V1(_response);
        });
    };
    AppWatch_ContentQueries_Client.prototype.processContentQueries_minutesListenedToday_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.7)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param planType (optional)
     */
    AppWatch_ContentQueries_Client.prototype.contentQueries_activeUsersCount_V1 = function (fromDate, toDate, planType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/active-users-count?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (planType === null)
            throw new Error("The parameter 'planType' cannot be null.");
        else if (planType !== undefined)
            url_ += "planType=" + encodeURIComponent("" + planType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentQueries_activeUsersCount_V1(_response);
        });
    };
    AppWatch_ContentQueries_Client.prototype.processContentQueries_activeUsersCount_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.8)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param plan (optional)
     * @deprecated
     */
    AppWatch_ContentQueries_Client.prototype.contentQueries_dailyActiveUsersCount_V1 = function (fromDate, toDate, plan, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/daily-active-users-count?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (plan === null)
            throw new Error("The parameter 'plan' cannot be null.");
        else if (plan !== undefined)
            url_ += "plan=" + encodeURIComponent("" + plan) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentQueries_dailyActiveUsersCount_V1(_response);
        });
    };
    AppWatch_ContentQueries_Client.prototype.processContentQueries_dailyActiveUsersCount_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.9)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    AppWatch_ContentQueries_Client.prototype.contentQueries_activeUsersHourlyBreakdown_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/active-users-hourly-breakdown?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentQueries_activeUsersHourlyBreakdown_V1(_response);
        });
    };
    AppWatch_ContentQueries_Client.prototype.processContentQueries_activeUsersHourlyBreakdown_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.10)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param plan (optional)
     */
    AppWatch_ContentQueries_Client.prototype.contentQueries_activeReadersMonthlyBreakdown_V1 = function (fromDate, toDate, plan, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/active-readers-monthly-breakdown?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (plan === null)
            throw new Error("The parameter 'plan' cannot be null.");
        else if (plan !== undefined)
            url_ += "plan=" + encodeURIComponent("" + plan) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentQueries_activeReadersMonthlyBreakdown_V1(_response);
        });
    };
    AppWatch_ContentQueries_Client.prototype.processContentQueries_activeReadersMonthlyBreakdown_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.11)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param plan (optional)
     */
    AppWatch_ContentQueries_Client.prototype.contentQueries_activeReadersWeeklyBreakdown_V1 = function (fromDate, toDate, plan, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/active-readers-weekly-breakdown?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (plan === null)
            throw new Error("The parameter 'plan' cannot be null.");
        else if (plan !== undefined)
            url_ += "plan=" + encodeURIComponent("" + plan) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentQueries_activeReadersWeeklyBreakdown_V1(_response);
        });
    };
    AppWatch_ContentQueries_Client.prototype.processContentQueries_activeReadersWeeklyBreakdown_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.8)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param plan (optional)
     */
    AppWatch_ContentQueries_Client.prototype.contentQueries_activeReadersDailyBreakdown_V1 = function (fromDate, toDate, plan, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/active-readers-daily-breakdown?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (plan === null)
            throw new Error("The parameter 'plan' cannot be null.");
        else if (plan !== undefined)
            url_ += "plan=" + encodeURIComponent("" + plan) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentQueries_activeReadersDailyBreakdown_V1(_response);
        });
    };
    AppWatch_ContentQueries_Client.prototype.processContentQueries_activeReadersDailyBreakdown_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.12)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param planType (optional)
     */
    AppWatch_ContentQueries_Client.prototype.contentQueries_userActiveRetentionAfterFirstSession_V1 = function (fromDate, toDate, planType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/user-active-retention-after-first-session?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (planType === null)
            throw new Error("The parameter 'planType' cannot be null.");
        else if (planType !== undefined)
            url_ += "PlanType=" + encodeURIComponent("" + planType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentQueries_userActiveRetentionAfterFirstSession_V1(_response);
        });
    };
    AppWatch_ContentQueries_Client.prototype.processContentQueries_userActiveRetentionAfterFirstSession_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.13)
     * @param userId (optional)
     * @param retentionPeriod (optional)
     */
    AppWatch_ContentQueries_Client.prototype.contentQueries_userDetailedRetentionAfterRegistration_V1 = function (userId, retentionPeriod, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/user-detailed-retention-after-registration?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (retentionPeriod === null)
            throw new Error("The parameter 'retentionPeriod' cannot be null.");
        else if (retentionPeriod !== undefined)
            url_ += "RetentionPeriod=" + encodeURIComponent("" + retentionPeriod) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentQueries_userDetailedRetentionAfterRegistration_V1(_response);
        });
    };
    AppWatch_ContentQueries_Client.prototype.processContentQueries_userDetailedRetentionAfterRegistration_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.14)
     */
    AppWatch_ContentQueries_Client.prototype.contentQueries_avgWeeklyUniqueReaders_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/avg-weekly-unique-readers";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentQueries_avgWeeklyUniqueReaders_V1(_response);
        });
    };
    AppWatch_ContentQueries_Client.prototype.processContentQueries_avgWeeklyUniqueReaders_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 120.15)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param contentType (optional)
     * @param limit (optional)
     */
    AppWatch_ContentQueries_Client.prototype.contentQueries_mostPopularContentEntities_V1 = function (fromDate, toDate, contentType, limit, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/ContentQueries/most-popular-content-entities?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        if (contentType === null)
            throw new Error("The parameter 'contentType' cannot be null.");
        else if (contentType !== undefined)
            url_ += "ContentType=" + encodeURIComponent("" + contentType) + "&";
        if (limit === null)
            throw new Error("The parameter 'limit' cannot be null.");
        else if (limit !== undefined)
            url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processContentQueries_mostPopularContentEntities_V1(_response);
        });
    };
    AppWatch_ContentQueries_Client.prototype.processContentQueries_mostPopularContentEntities_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return AppWatch_ContentQueries_Client;
}());
exports.AppWatch_ContentQueries_Client = AppWatch_ContentQueries_Client;
var AppWatch_IdentityQueries_Client = /** @class */ (function () {
    function AppWatch_IdentityQueries_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * (Auth policies: 122.0)
     * @param afterDate (optional)
     * @param toDate (optional)
     */
    AppWatch_IdentityQueries_Client.prototype.identityQueries_registeredUsersCount_V1 = function (afterDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/IdentityQueries/registered-users-count?";
        if (afterDate === null)
            throw new Error("The parameter 'afterDate' cannot be null.");
        else if (afterDate !== undefined)
            url_ += "afterDate=" + encodeURIComponent("" + afterDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processIdentityQueries_registeredUsersCount_V1(_response);
        });
    };
    AppWatch_IdentityQueries_Client.prototype.processIdentityQueries_registeredUsersCount_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 122.1)
     * @param userId (optional)
     */
    AppWatch_IdentityQueries_Client.prototype.identityQueries_userDevices_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/IdentityQueries/user-devices?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processIdentityQueries_userDevices_V1(_response);
        });
    };
    AppWatch_IdentityQueries_Client.prototype.processIdentityQueries_userDevices_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 122.2)
     * @param afterDate (optional)
     * @param toDate (optional)
     */
    AppWatch_IdentityQueries_Client.prototype.identityQueries_operationSystemBreakdown_V1 = function (afterDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/IdentityQueries/operation-system-breakdown?";
        if (afterDate === null)
            throw new Error("The parameter 'afterDate' cannot be null.");
        else if (afterDate !== undefined)
            url_ += "afterDate=" + encodeURIComponent("" + afterDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processIdentityQueries_operationSystemBreakdown_V1(_response);
        });
    };
    AppWatch_IdentityQueries_Client.prototype.processIdentityQueries_operationSystemBreakdown_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 122.3)
     */
    AppWatch_IdentityQueries_Client.prototype.identityQueries_weeklyRegisteredUsersBreakdown_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/IdentityQueries/weekly-registered-users-breakdown";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processIdentityQueries_weeklyRegisteredUsersBreakdown_V1(_response);
        });
    };
    AppWatch_IdentityQueries_Client.prototype.processIdentityQueries_weeklyRegisteredUsersBreakdown_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return AppWatch_IdentityQueries_Client;
}());
exports.AppWatch_IdentityQueries_Client = AppWatch_IdentityQueries_Client;
var AppWatch_PaymentQueries_Client = /** @class */ (function () {
    function AppWatch_PaymentQueries_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * (Auth policies: 121.1)
     * @param userId (optional)
     */
    AppWatch_PaymentQueries_Client.prototype.paymentQueries_userSubscriptionHistory_V1 = function (userId, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/user-subscription-history?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaymentQueries_userSubscriptionHistory_V1(_response);
        });
    };
    AppWatch_PaymentQueries_Client.prototype.processPaymentQueries_userSubscriptionHistory_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.1)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    AppWatch_PaymentQueries_Client.prototype.paymentQueries_usersSubscriptions_V1 = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/users-subscriptions?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaymentQueries_usersSubscriptions_V1(_response);
        });
    };
    AppWatch_PaymentQueries_Client.prototype.processPaymentQueries_usersSubscriptions_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.2)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    AppWatch_PaymentQueries_Client.prototype.paymentQueries_firstTimeSubscriptionCount_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/first-time-subscription-count?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaymentQueries_firstTimeSubscriptionCount_V1(_response);
        });
    };
    AppWatch_PaymentQueries_Client.prototype.processPaymentQueries_firstTimeSubscriptionCount_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.5)
     * @param fromDate (optional)
     */
    AppWatch_PaymentQueries_Client.prototype.paymentQueries_userRetentionForSinglePoint_V1 = function (fromDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/user-retention-for-single-point?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaymentQueries_userRetentionForSinglePoint_V1(_response);
        });
    };
    AppWatch_PaymentQueries_Client.prototype.processPaymentQueries_userRetentionForSinglePoint_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.4)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    AppWatch_PaymentQueries_Client.prototype.paymentQueries_subscriptionOverview_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/subscription-overview?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaymentQueries_subscriptionOverview_V1(_response);
        });
    };
    AppWatch_PaymentQueries_Client.prototype.processPaymentQueries_subscriptionOverview_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.6)
     * @param fromDatePoint (optional)
     * @param toDatePoint (optional)
     */
    AppWatch_PaymentQueries_Client.prototype.paymentQueries_userRetentionForMultiplePoints_V1 = function (fromDatePoint, toDatePoint, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/user-retention-for-multiple-points?";
        if (fromDatePoint === null)
            throw new Error("The parameter 'fromDatePoint' cannot be null.");
        else if (fromDatePoint !== undefined)
            url_ += "fromDatePoint=" + encodeURIComponent("" + fromDatePoint) + "&";
        if (toDatePoint === null)
            throw new Error("The parameter 'toDatePoint' cannot be null.");
        else if (toDatePoint !== undefined)
            url_ += "toDatePoint=" + encodeURIComponent("" + toDatePoint) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaymentQueries_userRetentionForMultiplePoints_V1(_response);
        });
    };
    AppWatch_PaymentQueries_Client.prototype.processPaymentQueries_userRetentionForMultiplePoints_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.7)
     */
    AppWatch_PaymentQueries_Client.prototype.paymentQueries_currentPremiumCount_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/current-premium-count";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaymentQueries_currentPremiumCount_V1(_response);
        });
    };
    AppWatch_PaymentQueries_Client.prototype.processPaymentQueries_currentPremiumCount_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.8)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    AppWatch_PaymentQueries_Client.prototype.paymentQueries_breakdownOfPremiumsByPurchaseSource_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/breakdown-of-premiums-by-purchase-source?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaymentQueries_breakdownOfPremiumsByPurchaseSource_V1(_response);
        });
    };
    AppWatch_PaymentQueries_Client.prototype.processPaymentQueries_breakdownOfPremiumsByPurchaseSource_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.10)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @deprecated
     */
    AppWatch_PaymentQueries_Client.prototype.paymentQueries_dailyBreakdownByPurchaseSource_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-breakdown-by-purchase-source?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaymentQueries_dailyBreakdownByPurchaseSource_V1(_response);
        });
    };
    AppWatch_PaymentQueries_Client.prototype.processPaymentQueries_dailyBreakdownByPurchaseSource_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.15)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param purchaseSourceType (optional)
     * @deprecated
     */
    AppWatch_PaymentQueries_Client.prototype.paymentQueries_dailyBreakdownByPurchaseSourceFilteredByPurchaseSourceType_V1 = function (fromDate, toDate, purchaseSourceType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-breakdown-by-purchase-source-filtered-by-purchase-source-type?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        if (purchaseSourceType === null)
            throw new Error("The parameter 'purchaseSourceType' cannot be null.");
        else if (purchaseSourceType !== undefined)
            url_ += "PurchaseSourceType=" + encodeURIComponent("" + purchaseSourceType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaymentQueries_dailyBreakdownByPurchaseSourceFilteredByPurchaseSourceType_V1(_response);
        });
    };
    AppWatch_PaymentQueries_Client.prototype.processPaymentQueries_dailyBreakdownByPurchaseSourceFilteredByPurchaseSourceType_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.17)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param subscriptionDuration (optional)
     * @param subscriptionType (optional)
     * @param purchaseSourceType (optional)
     */
    AppWatch_PaymentQueries_Client.prototype.paymentQueries_dailyAcquiredPremiumsByPurchaseSource_V1 = function (fromDate, toDate, subscriptionDuration, subscriptionType, purchaseSourceType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-acquired-premiums-by-purchase-source?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        if (subscriptionDuration !== undefined && subscriptionDuration !== null)
            url_ += "SubscriptionDuration=" + encodeURIComponent("" + subscriptionDuration) + "&";
        if (subscriptionType === null)
            throw new Error("The parameter 'subscriptionType' cannot be null.");
        else if (subscriptionType !== undefined)
            url_ += "SubscriptionType=" + encodeURIComponent("" + subscriptionType) + "&";
        if (purchaseSourceType === null)
            throw new Error("The parameter 'purchaseSourceType' cannot be null.");
        else if (purchaseSourceType !== undefined)
            url_ += "PurchaseSourceType=" + encodeURIComponent("" + purchaseSourceType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaymentQueries_dailyAcquiredPremiumsByPurchaseSource_V1(_response);
        });
    };
    AppWatch_PaymentQueries_Client.prototype.processPaymentQueries_dailyAcquiredPremiumsByPurchaseSource_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.9)
     * @param startYear (optional)
     * @param startWeek (optional)
     */
    AppWatch_PaymentQueries_Client.prototype.paymentQueries_firstTimeSubscriptionBreakdownByWeeks_V1 = function (startYear, startWeek, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/first-time-subscription-breakdown-by-weeks?";
        if (startYear === null)
            throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined)
            url_ += "startYear=" + encodeURIComponent("" + startYear) + "&";
        if (startWeek === null)
            throw new Error("The parameter 'startWeek' cannot be null.");
        else if (startWeek !== undefined)
            url_ += "startWeek=" + encodeURIComponent("" + startWeek) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaymentQueries_firstTimeSubscriptionBreakdownByWeeks_V1(_response);
        });
    };
    AppWatch_PaymentQueries_Client.prototype.processPaymentQueries_firstTimeSubscriptionBreakdownByWeeks_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.11)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    AppWatch_PaymentQueries_Client.prototype.paymentQueries_promoCodeAliasBreakdownBySource_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/promo-code-alias-breakdown-by-source?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaymentQueries_promoCodeAliasBreakdownBySource_V1(_response);
        });
    };
    AppWatch_PaymentQueries_Client.prototype.processPaymentQueries_promoCodeAliasBreakdownBySource_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.12)
     * @param stripeCustomerEmail (optional)
     * @param stripeCustomerId (optional)
     * @param userId (optional)
     * @param stripeSubscriptionId (optional)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    AppWatch_PaymentQueries_Client.prototype.paymentQueries_stripeSessions_V1 = function (stripeCustomerEmail, stripeCustomerId, userId, stripeSubscriptionId, fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/stripe-sessions?";
        if (stripeCustomerEmail !== undefined && stripeCustomerEmail !== null)
            url_ += "StripeCustomerEmail=" + encodeURIComponent("" + stripeCustomerEmail) + "&";
        if (stripeCustomerId !== undefined && stripeCustomerId !== null)
            url_ += "StripeCustomerId=" + encodeURIComponent("" + stripeCustomerId) + "&";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "UserId=" + encodeURIComponent("" + userId) + "&";
        if (stripeSubscriptionId !== undefined && stripeSubscriptionId !== null)
            url_ += "StripeSubscriptionId=" + encodeURIComponent("" + stripeSubscriptionId) + "&";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "fromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "toDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaymentQueries_stripeSessions_V1(_response);
        });
    };
    AppWatch_PaymentQueries_Client.prototype.processPaymentQueries_stripeSessions_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.13)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param subscriptionDuration (optional)
     * @param subscriptionType (optional)
     */
    AppWatch_PaymentQueries_Client.prototype.paymentQueries_dailyAquiredPremiumUsers_V1 = function (fromDate, toDate, subscriptionDuration, subscriptionType, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-aquired-premium-users?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        if (subscriptionDuration !== undefined && subscriptionDuration !== null)
            url_ += "SubscriptionDuration=" + encodeURIComponent("" + subscriptionDuration) + "&";
        if (subscriptionType === null)
            throw new Error("The parameter 'subscriptionType' cannot be null.");
        else if (subscriptionType !== undefined)
            url_ += "SubscriptionType=" + encodeURIComponent("" + subscriptionType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaymentQueries_dailyAquiredPremiumUsers_V1(_response);
        });
    };
    AppWatch_PaymentQueries_Client.prototype.processPaymentQueries_dailyAquiredPremiumUsers_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.14)
     * @param fromDate (optional)
     * @param toDate (optional)
     * @param subscriptionDuration (optional)
     */
    AppWatch_PaymentQueries_Client.prototype.paymentQueries_dailyLostPremiumUsers_V1 = function (fromDate, toDate, subscriptionDuration, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/daily-lost-premium-users?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        if (subscriptionDuration !== undefined && subscriptionDuration !== null)
            url_ += "SubscriptionDuration=" + encodeURIComponent("" + subscriptionDuration) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaymentQueries_dailyLostPremiumUsers_V1(_response);
        });
    };
    AppWatch_PaymentQueries_Client.prototype.processPaymentQueries_dailyLostPremiumUsers_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.16)
     */
    AppWatch_PaymentQueries_Client.prototype.paymentQueries_expectedToBeLostPremiums_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/expected-to-be-lost-premiums";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaymentQueries_expectedToBeLostPremiums_V1(_response);
        });
    };
    AppWatch_PaymentQueries_Client.prototype.processPaymentQueries_expectedToBeLostPremiums_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 121.18)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    AppWatch_PaymentQueries_Client.prototype.paymentQueries_dcpConversionPurchases_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/PaymentQueries/dcp-conversion-purchases?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processPaymentQueries_dcpConversionPurchases_V1(_response);
        });
    };
    AppWatch_PaymentQueries_Client.prototype.processPaymentQueries_dcpConversionPurchases_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return AppWatch_PaymentQueries_Client;
}());
exports.AppWatch_PaymentQueries_Client = AppWatch_PaymentQueries_Client;
var AppWatch_Stripe_Client = /** @class */ (function () {
    function AppWatch_Stripe_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * (Auth policies: 125.0)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    AppWatch_Stripe_Client.prototype.stripe_getGrossRevenue_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Stripe/get-gross-revenue?";
        if (fromDate !== undefined && fromDate !== null)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate !== undefined && toDate !== null)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processStripe_getGrossRevenue_V1(_response);
        });
    };
    AppWatch_Stripe_Client.prototype.processStripe_getGrossRevenue_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * (Auth policies: 125.1)
     */
    AppWatch_Stripe_Client.prototype.stripe_getCurrentBalance_V1 = function (cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/Stripe/get-current-balance";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processStripe_getCurrentBalance_V1(_response);
        });
    };
    AppWatch_Stripe_Client.prototype.processStripe_getCurrentBalance_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return AppWatch_Stripe_Client;
}());
exports.AppWatch_Stripe_Client = AppWatch_Stripe_Client;
var AppWatch_WajeezQueries_Client = /** @class */ (function () {
    function AppWatch_WajeezQueries_Client(baseUrl, instance) {
        this.jsonParseReviver = undefined;
        this.instance = instance ? instance : axios_1.default.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * (Auth policies: 123.0) (Scope: Dashboard)
     * @param pageNumber (optional)
     * @param pageSize (optional)
     */
    AppWatch_WajeezQueries_Client.prototype.wajeezQueries_premiumCustomers_V1 = function (pageNumber, pageSize, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/WajeezQueries/premium-customers?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWajeezQueries_premiumCustomers_V1(_response);
        });
    };
    AppWatch_WajeezQueries_Client.prototype.processWajeezQueries_premiumCustomers_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    /**
     * Conversion rate (Auth policies: 123.1) (Scope: Dashboard)
     * @param fromDate (optional)
     * @param toDate (optional)
     */
    AppWatch_WajeezQueries_Client.prototype.wajeezQueries_userSubscriptionConversionRate_V1 = function (fromDate, toDate, cancelToken) {
        var _this = this;
        var url_ = this.baseUrl + "/api/appWatch/v1/admin/WajeezQueries/user-subscription-conversion-rate?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (toDate === null)
            throw new Error("The parameter 'toDate' cannot be null.");
        else if (toDate !== undefined)
            url_ += "ToDate=" + encodeURIComponent("" + toDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken: cancelToken
        };
        return this.instance.request(options_).catch(function (_error) {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        }).then(function (_response) {
            return _this.processWajeezQueries_userSubscriptionConversionRate_V1(_response);
        });
    };
    AppWatch_WajeezQueries_Client.prototype.processWajeezQueries_userSubscriptionConversionRate_V1 = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (var k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        var _mappings = [];
        if (status === 200) {
            var _responseText = response.data;
            var result200 = null;
            var resultData200 = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            var _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    };
    return AppWatch_WajeezQueries_Client;
}());
exports.AppWatch_WajeezQueries_Client = AppWatch_WajeezQueries_Client;
/** 0 = Success 400 = BadRequest 403 = Forbidden 404 = NotFound 404 = UserNotFound 404 = RoleNotFound 404 = RoleClaimNotFound 405 = Unauthorized 406 = NotAcceptable 407 = MaxNumberOfSimultaneousLogins 410 = DeletionNotAllowed 411 = AlreadyExist 412 = InvalidEmail 413 = InvalidCode 414 = EmailTaken 415 = UserBlocked 416 = InvalidCredentials 417 = InvalidPassword 500 = InternalServerError */
var ResponseCode;
(function (ResponseCode) {
    ResponseCode[ResponseCode["Success"] = 0] = "Success";
    ResponseCode[ResponseCode["BadRequest"] = 400] = "BadRequest";
    ResponseCode[ResponseCode["Forbidden"] = 403] = "Forbidden";
    ResponseCode[ResponseCode["NotFound"] = 404] = "NotFound";
    ResponseCode[ResponseCode["UserNotFound"] = 404] = "UserNotFound";
    ResponseCode[ResponseCode["RoleNotFound"] = 404] = "RoleNotFound";
    ResponseCode[ResponseCode["RoleClaimNotFound"] = 404] = "RoleClaimNotFound";
    ResponseCode[ResponseCode["Unauthorized"] = 405] = "Unauthorized";
    ResponseCode[ResponseCode["NotAcceptable"] = 406] = "NotAcceptable";
    ResponseCode[ResponseCode["MaxNumberOfSimultaneousLogins"] = 407] = "MaxNumberOfSimultaneousLogins";
    ResponseCode[ResponseCode["DeletionNotAllowed"] = 410] = "DeletionNotAllowed";
    ResponseCode[ResponseCode["AlreadyExist"] = 411] = "AlreadyExist";
    ResponseCode[ResponseCode["InvalidEmail"] = 412] = "InvalidEmail";
    ResponseCode[ResponseCode["InvalidCode"] = 413] = "InvalidCode";
    ResponseCode[ResponseCode["EmailTaken"] = 414] = "EmailTaken";
    ResponseCode[ResponseCode["UserBlocked"] = 415] = "UserBlocked";
    ResponseCode[ResponseCode["InvalidCredentials"] = 416] = "InvalidCredentials";
    ResponseCode[ResponseCode["InvalidPassword"] = 417] = "InvalidPassword";
    ResponseCode[ResponseCode["InternalServerError"] = 500] = "InternalServerError";
})(ResponseCode = exports.ResponseCode || (exports.ResponseCode = {}));
/** 0 = Internal 1 = External */
var EndpointTypes;
(function (EndpointTypes) {
    EndpointTypes[EndpointTypes["Internal"] = 0] = "Internal";
    EndpointTypes[EndpointTypes["External"] = 1] = "External";
})(EndpointTypes = exports.EndpointTypes || (exports.EndpointTypes = {}));
/** 0 = Text 1 = DateTime 2 = Date 3 = CallbackSelect 4 = Select 5 = Number 6 = RangePicker 7 = Switch */
var EndpointFieldType;
(function (EndpointFieldType) {
    EndpointFieldType[EndpointFieldType["Text"] = 0] = "Text";
    EndpointFieldType[EndpointFieldType["DateTime"] = 1] = "DateTime";
    EndpointFieldType[EndpointFieldType["Date"] = 2] = "Date";
    EndpointFieldType[EndpointFieldType["CallbackSelect"] = 3] = "CallbackSelect";
    EndpointFieldType[EndpointFieldType["Select"] = 4] = "Select";
    EndpointFieldType[EndpointFieldType["Number"] = 5] = "Number";
    EndpointFieldType[EndpointFieldType["RangePicker"] = 6] = "RangePicker";
    EndpointFieldType[EndpointFieldType["Switch"] = 7] = "Switch";
})(EndpointFieldType = exports.EndpointFieldType || (exports.EndpointFieldType = {}));
/** 0 = Stats 1 = LinearChartTable 2 = LinearChartStats 3 = Table 4 = PieChart 5 = CountryChart 6 = MultiLine 7 = BarChart 8 = LineChart */
var SectionType;
(function (SectionType) {
    SectionType[SectionType["Stats"] = 0] = "Stats";
    SectionType[SectionType["LinearChartTable"] = 1] = "LinearChartTable";
    SectionType[SectionType["LinearChartStats"] = 2] = "LinearChartStats";
    SectionType[SectionType["Table"] = 3] = "Table";
    SectionType[SectionType["PieChart"] = 4] = "PieChart";
    SectionType[SectionType["CountryChart"] = 5] = "CountryChart";
    SectionType[SectionType["MultiLine"] = 6] = "MultiLine";
    SectionType[SectionType["BarChart"] = 7] = "BarChart";
    SectionType[SectionType["LineChart"] = 8] = "LineChart";
})(SectionType = exports.SectionType || (exports.SectionType = {}));
/** 0 = BOOK 1 = FICTION 2 = PODCAST 3 = CATEGORY 4 = SUBCATEGORY */
var ContentType;
(function (ContentType) {
    ContentType[ContentType["BOOK"] = 0] = "BOOK";
    ContentType[ContentType["FICTION"] = 1] = "FICTION";
    ContentType[ContentType["PODCAST"] = 2] = "PODCAST";
    ContentType[ContentType["CATEGORY"] = 3] = "CATEGORY";
    ContentType[ContentType["SUBCATEGORY"] = 4] = "SUBCATEGORY";
})(ContentType = exports.ContentType || (exports.ContentType = {}));
/** 0 = All 1 = PREMIUM 2 = FREEMIUM */
var PlanType;
(function (PlanType) {
    PlanType[PlanType["All"] = 0] = "All";
    PlanType[PlanType["PREMIUM"] = 1] = "PREMIUM";
    PlanType[PlanType["FREEMIUM"] = 2] = "FREEMIUM";
})(PlanType = exports.PlanType || (exports.PlanType = {}));
/** 0 = Daily 1 = Weekly 2 = Monthly */
var RetentionPeriod;
(function (RetentionPeriod) {
    RetentionPeriod[RetentionPeriod["Daily"] = 0] = "Daily";
    RetentionPeriod[RetentionPeriod["Weekly"] = 1] = "Weekly";
    RetentionPeriod[RetentionPeriod["Monthly"] = 2] = "Monthly";
})(RetentionPeriod = exports.RetentionPeriod || (exports.RetentionPeriod = {}));
/** 0 = MOBILE_STORE 1 = CARD_DIRECT 2 = INSTALLMENT_PLAN 3 = DCP_WALLET 4 = VOUCHER 5 = FREE 6 = INTERNAL 7 = OFFLINE 10 = Other */
var PurchaseSourceType;
(function (PurchaseSourceType) {
    PurchaseSourceType[PurchaseSourceType["MOBILE_STORE"] = 0] = "MOBILE_STORE";
    PurchaseSourceType[PurchaseSourceType["CARD_DIRECT"] = 1] = "CARD_DIRECT";
    PurchaseSourceType[PurchaseSourceType["INSTALLMENT_PLAN"] = 2] = "INSTALLMENT_PLAN";
    PurchaseSourceType[PurchaseSourceType["DCP_WALLET"] = 3] = "DCP_WALLET";
    PurchaseSourceType[PurchaseSourceType["VOUCHER"] = 4] = "VOUCHER";
    PurchaseSourceType[PurchaseSourceType["FREE"] = 5] = "FREE";
    PurchaseSourceType[PurchaseSourceType["INTERNAL"] = 6] = "INTERNAL";
    PurchaseSourceType[PurchaseSourceType["OFFLINE"] = 7] = "OFFLINE";
    PurchaseSourceType[PurchaseSourceType["Other"] = 10] = "Other";
})(PurchaseSourceType = exports.PurchaseSourceType || (exports.PurchaseSourceType = {}));
/** 0 = P1Y 1 = P1M 2 = P1W */
var SubscriptionDuration;
(function (SubscriptionDuration) {
    SubscriptionDuration[SubscriptionDuration["P1Y"] = 0] = "P1Y";
    SubscriptionDuration[SubscriptionDuration["P1M"] = 1] = "P1M";
    SubscriptionDuration[SubscriptionDuration["P1W"] = 2] = "P1W";
})(SubscriptionDuration = exports.SubscriptionDuration || (exports.SubscriptionDuration = {}));
/** 0 = New 1 = Renewal 2 = ALL */
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType[SubscriptionType["New"] = 0] = "New";
    SubscriptionType[SubscriptionType["Renewal"] = 1] = "Renewal";
    SubscriptionType[SubscriptionType["ALL"] = 2] = "ALL";
})(SubscriptionType = exports.SubscriptionType || (exports.SubscriptionType = {}));
/** 0 = Pending 1 = Active 2 = Renewed 3 = Canceled 4 = Updated */
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus[SubscriptionStatus["Pending"] = 0] = "Pending";
    SubscriptionStatus[SubscriptionStatus["Active"] = 1] = "Active";
    SubscriptionStatus[SubscriptionStatus["Renewed"] = 2] = "Renewed";
    SubscriptionStatus[SubscriptionStatus["Canceled"] = 3] = "Canceled";
    SubscriptionStatus[SubscriptionStatus["Updated"] = 4] = "Updated";
})(SubscriptionStatus = exports.SubscriptionStatus || (exports.SubscriptionStatus = {}));
function jsonParse(json, reviver) {
    json = JSON.parse(json, reviver);
    var byid = {};
    var refs = [];
    json = (function recurse(obj, prop, parent) {
        if (typeof obj !== 'object' || !obj)
            return obj;
        if ("$ref" in obj) {
            var ref = obj.$ref;
            if (ref in byid)
                return byid[ref];
            refs.push([parent, prop, ref]);
            return undefined;
        }
        else if ("$id" in obj) {
            var id = obj.$id;
            delete obj.$id;
            if ("$values" in obj)
                obj = obj.$values;
            byid[id] = obj;
        }
        if (Array.isArray(obj)) {
            obj = obj.map(function (v, i) { return recurse(v, i, obj); });
        }
        else {
            for (var p in obj) {
                if (obj.hasOwnProperty(p) && obj[p] && typeof obj[p] === 'object')
                    obj[p] = recurse(obj[p], p, obj);
            }
        }
        return obj;
    })(json);
    for (var i = 0; i < refs.length; i++) {
        var ref = refs[i];
        ref[0][ref[1]] = byid[ref[2]];
    }
    return json;
}
function createInstance(data, mappings, type) {
    if (!mappings)
        mappings = [];
    if (!data)
        return null;
    var mappingIndexName = "__mappingIndex";
    if (data[mappingIndexName])
        return mappings[data[mappingIndexName]].target;
    data[mappingIndexName] = mappings.length;
    var result = new type();
    mappings.push({ source: data, target: result });
    result.init(data, mappings);
    return result;
}
var ApiException = /** @class */ (function (_super) {
    __extends(ApiException, _super);
    function ApiException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isApiException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    ApiException.isApiException = function (obj) {
        return obj.isApiException === true;
    };
    return ApiException;
}(Error));
exports.ApiException = ApiException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
